import React, { useEffect, useState } from "react";
import axios from "../../api/axiosConfig";
import Loader from "../../components/Loader/Loader"; // Import your loader component
// import InsertModal from "./../../components/Popups/InsertRow";
import { ToastContainer, toast } from "react-toastify";
// import DynamicTable from "../../components/MUI Table/DynamicTable";
// import SymbolSearch from "../../components/Popups/SymbolSearch";
import NotificationCards from "../../components/Notification Card/Notification Card";
import { Pagination, Box, Button } from "@mui/material";
import EditModal from "../../components/Popups/EditRow";
import InsertModal from "../../components/Popups/InsertRow";

function Notifications() {
  const [loading, setLoading] = useState(false); // State for loading
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [notificationData, setnotificationData] = useState([]);
  const [rowID, setrowID] = useState("");
  const [selectedTable, setselectedTable] = useState("");
  const [formData, setFormData] = useState({}); // State for form data
  const [showEditModal, setShowEditModal] = useState(false);
  const [notificationID, setnotificationID] = useState("");
  const [showInsertModal, setShowInsertModal] = useState(false);

  useEffect(() => {
    fetchNotificcationData(1);
  }, []);

  const fetchNotificcationData = async (value) => {
    try {
      setLoading(true);
      const response = await axios.post("/news-notifs/fetch-notifications/", {
        page: value,
        limit: 10,
      });
      setnotificationData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching news data:", error);
      toast.error(error?.response?.data?.message || "Error fetching news");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    fetchNotificcationData(value);
  };

  const handleEditRowButton = async (table, id) => {
    setrowID(id);
    setselectedTable(table);
    setFormData({});
    setShowEditModal(true);
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setselectedTable("");
    setnotificationID("");
    setrowID("");
  };

  const handleInputChange = (column, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [column]: value,
    }));
  };

  const handleEditRow = async () => {
    try {
      setLoading(true);
      if (
        Object.keys(formData).length === 0 ||
        Object.values(formData).every((value) => value === "")
      ) {
        return toast.error(`You cannot send an empty data`);
      }

      const form = new FormData();
      Object.keys(formData).forEach((key) => {
        form.append(`data[${key}]`, formData[key]);
      });

      const response = await axios.patch("/insert/edit-row", form, {
        headers: { "Content-Type": "multipart/form-data" },
        params: { id: rowID, selectedTable },
      });
      if (response.status === 200) {
        toast.success("Row edited successfully");
      } else {
        toast.error(`Unexpected response code: ${response.status}`);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error editing row");
      console.error("Error editing row", error);
    } finally {
      setShowEditModal(false);
      setselectedTable("");
      setrowID("");
      fetchNotificcationData(page);
    }
  };

  // Update handleInsertClick to set columns
  const handleInsertRowButton = async (table) => {
    setselectedTable(table);
    setFormData({});
    setShowInsertModal(true);
  };

  const handleInsertModalClose = () => {
    setShowInsertModal(false);
    setselectedTable("");
    setnotificationID("");
  };

  const handleInsertRow = async () => {
    try {
      setLoading(true);
      if (
        Object.keys(formData).length === 0 ||
        Object.values(formData).every((value) => value === "")
      ) {
        return toast.error(`You cannot send an empty data`);
      }
      if (
        (selectedTable === "notification_profile" ||
          selectedTable === "notification_country" ||
          selectedTable === "notification_investor_type" ||
          selectedTable === "notification_asset" ||
          selectedTable === "notification_industry") &&
        !formData.notification
      ) {
        formData.notification = notificationID; // If it's not already set, assign newsID
      }

      if (rowID && rowID !== "") {
        formData.id = rowID;
      }

      const form = new FormData();
      form.append("selectedTable", selectedTable);
      Object.keys(formData).forEach((key) => {
        form.append(`data[${key}]`, formData[key]);
      });

      const response = await axios.post(
        "/insert/insert-single-without-symbol",
        form,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        toast.success("Data inserted successfully");
      } else {
        toast.error(`Unexpected response code: ${response.status}`);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error inserting row");
      console.error("Error inserting data", error);
    } finally {
      setShowInsertModal(false);
      setselectedTable("");
      setnotificationID("");
      fetchNotificcationData(page);
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <Loader />
        </div>
      )}
      <Box sx={{ marginBottom: "20px" }}>
        <div className="card h-100">
          <div className="card-header">
            <h4 className="mb-0">Filters</h4>
          </div>
          <div className="card-body">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                color: "white",
                marginLeft: "20px",
              }}
              onClick={() => handleInsertRowButton("notification")}
            >
              Add Notification
            </Button>
          </div>
        </div>
      </Box>
      <div className="row equal-height">
        <div className="col-md-12 mb-4">
          <div className="card h-100">
            <div className="card-header">
              <h4 className="mb-0">Notifications</h4>
            </div>
            <div className="card-body">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                sx={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              />
              <NotificationCards
                notificationData={notificationData}
                setnotificationID={setnotificationID}
                handleInsertRowButton={handleInsertRowButton}
                handleEditRowButton={handleEditRowButton}
              />
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Insert Modal Popup */}
      <div>
        <InsertModal
          show={showInsertModal}
          handleClose={handleInsertModalClose}
          tableTitle={selectedTable}
          handleInputChange={handleInputChange}
          handleInsertRow={handleInsertRow}
          foreignID={notificationID}
        />
      </div>
      {/* Edit Modal Popup */}
      <div>
        <EditModal
          show={showEditModal}
          id={rowID}
          handleClose={handleEditModalClose}
          tableTitle={selectedTable}
          handleInputChange={handleInputChange}
          handleEditRow={handleEditRow}
          foreignID={notificationID}
        />
      </div>
      <ToastContainer />
    </>
  );
}

export default Notifications;
